import * as Yup from 'yup';


export const change_password_schema = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
};

export const change_password_validation_schema = Yup.object().shape({
    oldPassword: Yup.string()
        .required('Old password is required'),

    newPassword: Yup.string()
        .required('New password is required'),

    confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword')], 'Passwords do not match')
        .required('Confirm password is required'),
});
